import { Box, Flex, Text, Skeleton, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import app from 'configs/app/app';
import Hint from 'ui/shared/Hint';

type Props = {
  label: string;
  value: string;
  hint?: string;
  isLoading?: boolean;
  diff?: string | number;
  diffFormatted?: string;
  diffPeriod?: '24h';
}

const cartBackground = app.baseUrl + '/static/backgrounds/cart.png';

const StatsWidget = ({ label, value, isLoading, hint, diff, diffPeriod = '24h', diffFormatted }: Props) => {
  // const bgColor = useColorModeValue('blue.50', 'whiteAlpha.100');
  const skeletonBgColor = useColorModeValue('blackAlpha.50', 'whiteAlpha.50');
  const hintColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Flex
      alignItems="flex-start"
      bgImg={ isLoading ? skeletonBgColor : cartBackground }
      bgSize="100% 100%"
      border="2px solid rgba(255, 255, 255, 0.22)"
      px={ 3 }
      py={{ base: 2, lg: 3 }}
      borderRadius="md"
      justifyContent="space-between"
      columnGap={ 3 }
    >
      <Box>
        <Skeleton
          isLoaded={ !isLoading }
          fontSize="10px"
          lineHeight="20px"
          textTransform="uppercase"
          w="fit-content"
        >
          <span>{ label }</span>
        </Skeleton>
        <Skeleton
          isLoaded={ !isLoading }
          w="fit-content"
          display="flex"
          alignItems="baseline"
          mt={ 1 }
        >
          <Text
            fontWeight={ 500 }
            fontSize="lg"
            lineHeight={ 6 }
            bgClip="text"
            bgGradient="linear-gradient(90deg, #1FFFA3 0%, #8C47F5 100%)"
          >{ value }</Text>
          { diff && Number(diff) > 0 && (
            <>
              <Text fontWeight={ 500 } ml={ 2 } mr={ 1 } fontSize="lg" lineHeight={ 6 } color="green.500">
                +{ diffFormatted || Number(diff).toLocaleString() }
              </Text>
              <Text variant="secondary" fontSize="sm">({ diffPeriod })</Text>
            </>
          ) }
        </Skeleton>
      </Box>
      { hint && (
        <Skeleton isLoaded={ !isLoading } alignSelf="center" borderRadius="base">
          <Hint label={ hint } boxSize={ 6 } color={ hintColor } iconColor="rgba(255, 255, 255, 0.7)"/>
        </Skeleton>
      ) }
    </Flex>
  );
};

export default StatsWidget;
